import config from "../config/application"
import { apiCall } from "./common/base.service"
import { apiCallExpose } from "./common/oauthSupplier.service"
import permission from "./permissions.service"
import dictionary from "../config/dictionary"

const save = "register/user"
const terms = "find/TDR"
const sup = "/find"
const delete_supplier = "delete"
const edit_supplier = "edit"
const provider = "/find"
const email = "/send_by_supplier"
const supplier_profile = "/supplier_profile"
const find_profile = "/find_profile"
const pending = "/pending-document/"
const exportSupplier = "export"

class SupplierService {
  saveSupplier(json) {
    const url = `${config.data.providers.provider.url}${save}`
    return apiCallExpose("post", url, json)
  }

  getTerms() {
    const url = `${config.data.providers.type.url}${terms}`
    return apiCallExpose("get", url)
  }
  getProviders = json => {
    const url = `${config.data.providers.provider.url}${provider}`
    return apiCallExpose("put", url, json)
  }
  getSuppliers(filter) {
    const url = `${config.data.providers.supplier.url}${sup}`
    return apiCall("post", url, filter.filter)
  }

  async deleteSuppliers(sup, status) {
    const json = {
      status: status,
      supplierList: sup,
    }
    const url = `${config.data.providers.supplier.url}/${delete_supplier}`
    const userAux = JSON.parse(sessionStorage.getItem("user"))
    const validPermission = await supplierService.getPermissions(
      userAux.id.user.username,
      dictionary.configApp.action.delete
    )
    const error = validPermission?.response?.data?.error
    return error ? validPermission : apiCall("post", url, json)
  }

  async editSupplier(supplier) {
    const url = `${config.data.providers.supplier.url}/${edit_supplier}`
    const userAux = JSON.parse(sessionStorage.getItem("user"))
    const validPermission = await supplierService.getPermissions(
      userAux.id.user.username,
      dictionary.configApp.action.edit
    )
    const error = validPermission?.response?.data?.error
    return error ? validPermission : apiCall("post", url, supplier)
  }

  sendEmails(supplierId) {
    const url = `${config.data.providers.email.url}${email}`
    return apiCall("post", url, supplierId)
  }

  async saveSupplierProfile(data) {
    const url = `${config.data.providers.supplier.url}${supplier_profile}`
    const userAux = JSON.parse(sessionStorage.getItem("user"))
    const validPermission = await supplierService.getPermissionsProfile(
      userAux.id.user.username,
      dictionary.configApp.action.add
    )
    const error = validPermission?.response?.data?.error
    return error ? validPermission : apiCall("post", url, data)
  }

  async getSupplierProfile(id) {
    const url = `${config.data.providers.supplier.url}${find_profile}/${id}`
    const userAux = JSON.parse(sessionStorage.getItem("user"))
    const validPermission = await supplierService.getPermissionsProfile(
      userAux.id.user.username,
      dictionary.configApp.action.list
    )
    const error = validPermission?.response?.data?.error
    return error ? validPermission : apiCall("get", url)
  }

  getFileRequirement(idSupplier) {
    const url = `${config.data.providers.supplier.url}${pending}${idSupplier}`
    return apiCall("get", url)
  }

  exportSupplier(supplierId) {
    const url = `${config.data.providers.supplier.url}/${exportSupplier}/${supplierId}`
    return apiCall("put", url)
  }

  getPermissions = (username, action) => {
    return permission.validPermission(
      process.env.REACT_APP_TRANSACTION_TYPE,
      username,
      process.env.REACT_APP_SYSTEM_CODE,
      action
    )
  }

  getPermissionsProfile = (username, action) => {
    return permission.validPermission(
      process.env.REACT_APP_TRANSACTION_PROFILE_SUPPLIER,
      username,
      process.env.REACT_APP_SYSTEM_CODE,
      action
    )
  }
}
const supplierService = new SupplierService()
export default supplierService
